<template>
	<div class="index-swiper-view swiper-view">
		<!-- 首页 -->
		<div v-if="custom.isMain">
			<van-swipe :autoplay="2000">
				<van-swipe-item v-for="item in custom.home_banner"
								:key="item.id">
					<div class="swiper-banner-wrap">
						<BannerItem v-bind="item" />
					</div>
				</van-swipe-item>
			</van-swipe>
			<div v-for="(titem,indexs) in custom.rankList" :key="indexs" class="mainitem">
				<TopBar :bannerType="titem.type" :custom="titem" :hasBorder='hasBorder'/>
				<CardItem class="carditem" :topinfo="titem" :bannerType="titem.type" :isHidden='isHidden'>
					<template #echartitem>
						<Ranking :ranklist="titem" :isHidden='isHidden'/>
					</template>
				</CardItem>
			</div>
		</div>
		<!-- 绿色开发 -->
		<div v-if="custom.id == '101'">
			<div class="shadowlayout">
				<TopBar :bannerType="custom.bannerType" :custom="custom"/>
				<div class="chartlayout">
					<CardItem class="carditem" :topinfo="custom.echartdata.linedata" :bannerType="custom.bannerType">
						<template #echartitem>
							<LineEcharts :echartdata="custom.echartdata" />
						</template>
					</CardItem>
					<CardItem class="carditem" :topinfo="custom.echartdata.columdata" :bannerType="custom.bannerType">
						<template #echartitem>
							<ColumEcharts :echartdata="custom.echartdata" />
						</template>
					</CardItem>
					<DataBaseBtn />
					<CardItem class="carditem" :topinfo="custom.rankList" :isHidden='hiddenRank' :bannerType="custom.bannerType">
						<template #echartitem>
							<Ranking :ranklist="custom.rankList" :isHidden='hiddenRank'/>
						</template>
					</CardItem>
				</div>
			</div>
			<TabItem :tablist="custom.tabList"/>
		</div>
		<!-- 绿色运营 -->
		<div v-if="custom.id == '102'">
			<div class="shadowlayout">
				<TopBar v-if="!isMain" :bannerType="custom.bannerType" :custom="custom"/>
				<div class="chartlayout">
					<CardItem class="carditem" :topinfo="custom.echartdata.linedata" :bannerType="custom.bannerType">
						<template #echartitem>
							<LineEcharts :echartdata="custom.echartdata" />
						</template>
					</CardItem>
					<CardItem class="carditem" :topinfo="custom.echartdata.columdata" :bannerType="custom.bannerType">
						<template #echartitem>
							<ColumEcharts :echartdata="custom.echartdata" />
						</template>
					</CardItem>
					<DataBaseBtn />
					<CardItem class="carditem" :topinfo="custom.rankList" :bannerType="custom.bannerType">
						<template #echartitem>
							<Ranking :ranklist="custom.rankList"/>
						</template>
					</CardItem>
				</div>
			</div>
			<TabItem :tablist="custom.tabList"/>
		</div>
		<!-- 绿色建筑 -->
		<div v-if="custom.id == '103'">
			<div class="shadowlayout">
				<TopBar v-if="!isMain" :bannerType="custom.bannerType" :custom="custom"/>
				<div class="chartlayout">
					<CardItem class="carditem" :topinfo="custom.echartdata.columdata" :bannerType="custom.bannerType">
						<template #echartitem>
							<ColumEcharts :echartdata="custom.echartdata" />
						</template>
					</CardItem>
					<CardItem class="carditem" :topinfo="custom.echartdata.linedata" :bannerType="custom.bannerType">
						<template #echartitem>
							<PieEcharts :echartdata="custom.echartdata.piedata" />
						</template>
					</CardItem>
					<DataBaseBtn />
					<CardItem class="carditem" :topinfo="custom.rankList" :bannerType="custom.bannerType">
						<template #echartitem>
							<Ranking :ranklist="custom.rankList" :isHidden='hiddenRank'/>
						</template>
					</CardItem>
				</div>
			</div>
			<TabItem :tablist="custom.tabList"/>
		</div> 
		<!-- 健康建筑建筑 -->
		<div v-if="custom.id == '104'">
			<div class="shadowlayout">
				<TopBar v-if="!isMain" :bannerType="custom.bannerType" :custom="custom"/>
				<div class="chartlayout">
					<CardItem class="carditem" :topinfo="custom.echartdata.columdata" :bannerType="custom.bannerType">
						<template #echartitem>
							<ColumEcharts :echartdata="custom.echartdata" />
						</template>
					</CardItem>
					<CardItem class="carditem" :topinfo="custom.echartdata.piedata" :bannerType="custom.bannerType">
						<template #echartitem>
							<PieEcharts :echartdata="custom.echartdata.piedata" />
						</template>
					</CardItem>
					<DataBaseBtn />
					<CardItem class="carditem" :topinfo="custom.rankList" :bannerType="custom.bannerType">
						<template #echartitem>
							<Ranking :ranklist="custom.rankList"/>
						</template>
					</CardItem>
				</div>
			</div>
			<TabItem :tablist="custom.tabList"/>
		</div>
	</div>
</template>
<script>
import PopLoading from '../../components/PopLoading'
import { Swipe, SwipeItem } from 'vant';
import DigitalItem from '../../components/DigitalItem';
import BannerItem from '../../components/BannerItem';
import TopBar from '@/components/TopBar'
import LineEcharts from '@/components/LineEcharts'
import CardItem from '@/components/CardItem'
import ColumEcharts from '@/components/ColumEcharts'
import Ranking from '@/components/Ranking'
import TabItem from '@/components/TabItem'
import PieEcharts from '@/components/PieEcharts'
import DataBaseBtn from '@/components/DataBaseBtn'
export default {
	name: 'indexSwiperView',
	components: {
		'van-swipe': Swipe,
		'van-swipe-item': SwipeItem,
		DigitalItem,
		BannerItem,
		TopBar,
		LineEcharts,
		CardItem,
		ColumEcharts,
		Ranking,
		TabItem,
		PieEcharts,
		DataBaseBtn
	},
	data(){
		return{
			// 组件取消border
			hasBorder:true,
			// 首页排行布局隐藏顶部及底部更多布局
			isHidden:true,
			hiddenRank: false,
			bannerArr: [
				{
					img_path: require('@/assets/images/about.png'),
					jump_id: 0,
					title: "vip首页幻灯片",
					type: 6
				},
				{
					img_path: require('@/assets/images/about.png'),
					jump_id: 0,
					title: "vip首页幻灯片",
					type: 6
				}
			]
		}
	},
	watch:{
	},
	props: ['isMain', 'newsItemList', 'digitalList', 'custom', 'cate_id', 'isNoContent','bannerType'],
	created() {
		console.log(this.custom)
	},
	mounted(){
		// envnetBus.$on('goGreens',val => {
		// 	this.goAssignBlock(val)
		// })
	},
	methods:{
		goAssignBlock(index) {
			this.$nextTick(() => {
				document.getElementById('block'+index).scrollIntoView();
			})
    }
	}
};
</script>

<style lang="stylus" scoped>
.shadowlayout{
	margin: 36px auto 0 auto;
	width: 690px;
	border-radius: 20px;
	box-shadow: 0px 1px 15px 0px rgba(22, 22, 22, 0.35);
}
.chartlayout{
	border: solid 1px #d9d9d9;
	border-bottom-left-radius: 20px;
	border-bottom-right-radius: 20px;
}
.mainitem{
	// margin-bottom: 40px;
	width: 690px;
  margin: 36px auto 40px auto;
	box-shadow: 0px 1px 15px 0px rgba(22, 22, 22, 0.35);
	border-radius: 20px;
}
.carditem{
	width: 690px;
}
.index-swiper-view {
	// margin: 40px 0;
	min-height: 1080px;
	.swiper-banner-wrap {
		margin: 30px auto;
		width: 690px;
		height: 273px;
		border-radius: 12px;
		overflow: hidden;
	}
	.news-list {
		padding: 0 15px;
	}
	.digital-list {
		padding: 20px 15px 90px 15px;

		.digital-item-comp {
			margin: 30px 15px 15px 15px;
			vertical-align: top;
		}

		.no-content {
			height: 90px;
			line-height: 90px;
			color: #999;
			text-align: center;
		}
	}

	.content-wrap {
		padding: 0 36px;
		color:#333;
		font-size:30px;
		line-height: 50px;
	}
}
</style>
